const SCOPE = 'app/subscribe/';
export const ActionTypes = {
    CHANGE_IS_ALREADY: `${SCOPE}CHANGE_IS_ALREADY`,
    CHANGE_IS_ERROR: `${SCOPE}CHANGE_IS_ERROR`,
    CHANGE_IS_LOADING: `${SCOPE}CHANGE_IS_LOADING`,
    CHANGE_EMAIL: `${SCOPE}CHANGE_EMAIL`,
    CHANGE_ERROR_MESSAGE: `${SCOPE}CHANGE_ERROR_MESSAGE`,
    SUBMIT: `${SCOPE}SUBMIT`,
};

export const changeIsAlready = () => ({
    type: ActionTypes.CHANGE_IS_ALREADY,
});

export const changeIsError = (isError) => ({
    type: ActionTypes.CHANGE_IS_ERROR,
    isError,
});

export const changeIsLoading = (isLoading) => ({
    type: ActionTypes.CHANGE_IS_LOADING,
    isLoading,
});

export const changeEmail = (email) => ({
    type: ActionTypes.CHANGE_EMAIL,
    email,
});

export const changeErrorMessage = (errorMessage) => ({
    type: ActionTypes.CHANGE_ERROR_MESSAGE,
    errorMessage,
});

export const submit = () => ({
    type: ActionTypes.SUBMIT,
});
